<script>
    import { Overlay, layout_cnv } from '../../'

    export default {
        name: 'Kagi',
        mixins: [Overlay],
        methods: {
            meta_info() {
                return {
                    author: 'TradingCandle',
                    version: '1.1.0',
                    desc: 'Kagi Chart',
                    preset: {
                        name: 'Kagi',
                        side: 'onchart',
                        settings: {
                            reversalAmount: 'auto',
                            colorCandleUp: '#23a776',
                            colorCandleDw: '#e54150',
                            lineWidth: 1
                        }
                    }
                }
            },
            init() {},
            draw(ctx) {
                let layout = this.$props.layout

                if (this.$props.sub === this.$props.data) {
                    var candles = layout.candles
                } else {
                    candles = layout_cnv(this).candles
                }

                if (!candles || candles.length < 2) return

                let reversalAmount = this.getReversalAmount(candles)
                if (reversalAmount <= 0) return

                // Build Kagi path: a series of vertical and horizontal segments
                let path = this.buildKagiPath(candles, reversalAmount, layout)
                if (path.length < 2) return

                // Render the Kagi path
                this.renderPath(ctx, path)
            },
            buildKagiPath(candles, reversalAmount, layout) {
                // Kagi tracks close prices and draws vertical lines
                // Direction changes on reversal, thickness changes on breaking prior high/low
                let points = [] // {x, y, thick, direction}
                let direction = 0 // 1=up, -1=down
                let currentExtreme = candles[0].raw[4]
                let lastTurnPrice = currentExtreme
                let priorHigh = -Infinity
                let priorLow = Infinity
                let currentX = candles[0].x

                // Start point
                let startY = Math.floor(currentExtreme * layout.A + layout.B)
                points.push({ x: currentX, y: startY, thick: false, up: true })

                for (var i = 1, n = candles.length; i < n; i++) {
                    let close = candles[i].raw[4]
                    let x = candles[i].x

                    if (direction === 0) {
                        // Determine initial direction
                        if (close - lastTurnPrice >= reversalAmount) {
                            direction = 1
                            currentExtreme = close
                            currentX = x
                        } else if (lastTurnPrice - close >= reversalAmount) {
                            direction = -1
                            currentExtreme = close
                            currentX = x
                        }
                        continue
                    }

                    if (direction === 1) {
                        if (close > currentExtreme) {
                            currentExtreme = close
                            currentX = x
                        } else if (currentExtreme - close >= reversalAmount) {
                            // Reversal: draw up line to extreme, then step right, then start down
                            let thick = currentExtreme > priorHigh
                            let yExtreme = Math.floor(currentExtreme * layout.A + layout.B)
                            points.push({ x: currentX, y: yExtreme, thick: thick, up: true })

                            priorHigh = currentExtreme
                            lastTurnPrice = currentExtreme
                            currentExtreme = close
                            direction = -1

                            // Horizontal step to new x
                            points.push({ x: x, y: yExtreme, thick: false, up: false, step: true })
                            currentX = x
                        }
                    } else {
                        if (close < currentExtreme) {
                            currentExtreme = close
                            currentX = x
                        } else if (close - currentExtreme >= reversalAmount) {
                            // Reversal: draw down line to extreme, then step right, then start up
                            let thick = currentExtreme < priorLow
                            let yExtreme = Math.floor(currentExtreme * layout.A + layout.B)
                            points.push({ x: currentX, y: yExtreme, thick: thick, up: false })

                            priorLow = currentExtreme
                            lastTurnPrice = currentExtreme
                            currentExtreme = close
                            direction = 1

                            // Horizontal step to new x
                            points.push({ x: x, y: yExtreme, thick: false, up: true, step: true })
                            currentX = x
                        }
                    }
                }

                // Final point
                let yFinal = Math.floor(currentExtreme * layout.A + layout.B)
                let thick = direction === 1 ? currentExtreme > priorHigh : currentExtreme < priorLow
                points.push({ x: currentX, y: yFinal, thick: thick, up: direction === 1 })

                return points
            },
            renderPath(ctx, points) {
                for (var i = 1; i < points.length; i++) {
                    let prev = points[i - 1]
                    let curr = points[i]

                    // Determine color and thickness
                    if (curr.step) {
                        // Horizontal connector - thin gray
                        ctx.strokeStyle = '#787b86'
                        ctx.lineWidth = 1
                    } else if (curr.up) {
                        ctx.strokeStyle = this.upColor
                        ctx.lineWidth = curr.thick ? 3 : 1.5
                    } else {
                        ctx.strokeStyle = this.downColor
                        ctx.lineWidth = curr.thick ? 3 : 1.5
                    }

                    ctx.beginPath()
                    ctx.moveTo(Math.floor(prev.x) + 0.5, Math.floor(prev.y) + 0.5)
                    ctx.lineTo(Math.floor(curr.x) + 0.5, Math.floor(curr.y) + 0.5)
                    ctx.stroke()
                }
            },
            getReversalAmount(candles) {
                if (this.sett.reversalAmount && this.sett.reversalAmount !== 'auto') {
                    return parseFloat(this.sett.reversalAmount)
                }
                // Auto: use 1x ATR (average true range of visible candles)
                let sum = 0
                for (var i = 0, n = candles.length; i < n; i++) {
                    sum += candles[i].raw[2] - candles[i].raw[3]
                }
                return (sum / candles.length) * 1.5
            },
            use_for() { return ['Kagi'] },
            y_range() {
                var hi = -Infinity, lo = Infinity
                for (var i = 0, n = this.sub.length; i < n; i++) {
                    let x = this.sub[i]
                    if (x[2] > hi) hi = x[2]
                    if (x[3] < lo) lo = x[3]
                }
                return [hi, lo]
            }
        },
        computed: {
            sett() { return this.$props.settings },
            upColor() { return this.sett.colorCandleUp || this.$props.colors.candleUp || '#23a776' },
            downColor() { return this.sett.colorCandleDw || this.$props.colors.candleDw || '#e54150' },
            lineWidth() { return this.sett.lineWidth || 1 }
        }
    }
</script>
